import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { SiteConfigContext } from '@bingads-webui-campaign-react/smart-page-context';
import {
  getComponentById,
  DATA_SOURCE_KEY_MAPPING,
  getDataSourceByKeys,
} from '@bingads-webui-campaign-react/smart-component-util';

import { SmartSummaryView } from './smart-summary-view';
import { placeholderValues, dataProperties } from './data-config';

export const SmartSummaryConnector = ({ id }) => {
  const { siteConfig } = useContext(SiteConfigContext);
  const { aboutUs, businessSummary } = getComponentById(siteConfig, id);

  const [
    businessDescription,
  ] = getDataSourceByKeys(siteConfig, [
    DATA_SOURCE_KEY_MAPPING.BusinessDescription,
  ]);

  return (
    <SmartSummaryView
      aboutUs={aboutUs || placeholderValues[dataProperties.aboutUs]}
      summary={
        businessSummary
        || businessDescription
        || placeholderValues[dataProperties.businessSummary]
      }
      id={id}
    />
  );
};

SmartSummaryConnector.propTypes = {
  id: PropTypes.string.isRequired,
};
